<template>
  <div class="kefu-free-tip">
     <div class="kefu-free-tip-inner">
         <div class="tip-icon">
             <img :src="require('./assets/tip.svg')">
         </div>
         <div class="tip-content">
             <p class="tip-content-text">此用户未经腾讯认证，聊天中请注意保护您的个人信息安全，您也可随时结束会话。</p>
         </div>

     </div>
     <div class="tip-close" @click="handleClose">
       <img :src="require('./assets/tip-close.svg')">
     </div>
 </div>
</template>

<script>
export default {
  methods: {
    handleClose() {
      this.$emit('onClose');
    },
  },
};
</script>
<style lang="less" scoped>
.kefu-free-tip {
   position: relative;
   z-index: 9999;
   background: #F0F6FF;
   display: flex;
   width: 100%;
   box-sizing: border-box;
   align-items: flex-start;
   padding: 8px;
   border-radius: 3px;
   .kefu-free-tip-inner {
     display: flex;
     width: 100%;
     box-sizing: border-box;
     align-items: flex-start;
     border-radius: 3px;
   }

   .tip-content {
       font-weight: 400;
       font-size: 14px;
       line-height: 20px;
       color: #262D3D;
       margin: 0 8px;
       p {
         margin: 0;
       }
   }

   .tip-close {
       padding: 2px;
       cursor: pointer;
   }
}
</style>
